const waitForImage = (url) => new Promise((resolve, reject) => {
  const image = new window.Image();
  image.onload = () => resolve(image);
  image.onerror = reject;
  image.src = url;
});

const resolveCssVariables = (svg, value) => {
  const computedStyle = window.getComputedStyle(svg);

  return value.replace(/var\((--[\w-]+)(?:,\s*([^)]+))?\)/g, (match, name, fallback) => {
    return computedStyle.getPropertyValue(name).trim() || fallback || match;
  });
};

const svgToPng = async (svg, backgroundColor) => {
  const bounds = svg.getBoundingClientRect();
  const width = Math.max(Math.ceil(bounds.width), 1);
  const height = Math.max(Math.ceil(bounds.height), 1);
  const clone = svg.cloneNode(true);

  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  clone.setAttribute('width', width);
  clone.setAttribute('height', height);

  const serialized = resolveCssVariables(svg, new XMLSerializer().serializeToString(clone));
  const url = window.URL.createObjectURL(new Blob([serialized], { type: 'image/svg+xml;charset=utf-8' }));

  try {
    const image = await waitForImage(url);
    const scale = 2;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = width * scale;
    canvas.height = height * scale;
    context.scale(scale, scale);
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, width, height);
    context.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL('image/png');
  } finally {
    window.URL.revokeObjectURL(url);
  }
};

export const captureManagementReportCharts = async (container) => {
  if (!container) {
    return [];
  }

  const cards = Array.from(container.querySelectorAll('.management-reports-chart__container'));
  const containerWidth = container.getBoundingClientRect().width;

  return Promise.all(cards.map(async (card) => {
    const svg = card.querySelector('svg');
    const title = card.children[0];
    const subtitle = card.children[1];
    const cardStyle = window.getComputedStyle(card);
    const backgroundColor = cardStyle.backgroundColor || '#FFFFFF';

    if (!svg) {
      throw new Error(`Unable to export chart: ${title?.textContent || 'Untitled chart'}`);
    }

    return {
      title: title?.textContent || '',
      subtitle: subtitle?.textContent || '',
      titleColor: title ? window.getComputedStyle(title).color : '#202124',
      subtitleColor: subtitle ? window.getComputedStyle(subtitle).color : '#666666',
      backgroundColor,
      fullWidth: card.getBoundingClientRect().width > containerWidth * 0.75,
      image: await svgToPng(svg, backgroundColor),
    };
  }));
};
